import React, { useState, useEffect } from "react";
import { Modal, Button, Table, Spinner } from "react-bootstrap";
import { useNavigate } from "react-router-dom";
import { getPlayerRegisterReport } from "../../../services/ReportService";

const RegistrationSummaryModal = ({ show, onHide }) => {
  const navigate = useNavigate();
  const [data, setData] = useState([]);
  const [loading, setLoading] = useState(false);

  useEffect(() => {
    if (show) {
      fetchPreviewData();
    }
  }, [show]);

  const fetchPreviewData = async () => {
    setLoading(true);
    try {
      const res = await getPlayerRegisterReport(0, 10, "");
      const items = Array.isArray(res) ? res : res?.content || res?.data || [];
      setData(items);
    } catch (error) {
      console.error("Error fetching preview registration data:", error);
    } finally {
      setLoading(false);
    }
  };

  const handleShowMore = () => {
    onHide();
    navigate("/admin/player-registration-reports");
  };

  return (
    <Modal show={show} onHide={onHide} size="lg" centered>
      <Modal.Header closeButton>
        <Modal.Title className="fs-18 fw-bold">
          <i className="fas fa-user-plus text-primary me-2"></i>
          Registration Summary - Recent Records
        </Modal.Title>
      </Modal.Header>
      <Modal.Body>
        {loading ? (
          <div className="text-center py-5">
            <Spinner animation="border" variant="primary" />
            <p className="mt-2 text-muted">Loading registrations...</p>
          </div>
        ) : (
          <div className="table-responsive">
            <Table hover responsive className="align-middle mb-0">
              <thead className="table-light">
                <tr>
                  <th>#</th>
                  <th>Player Name</th>
                  <th>Age Category</th>
                  <th>Gender</th>
                  <th>Mobile</th>
                  <th>Status</th>
                </tr>
              </thead>
              <tbody>
                {data?.length > 0 ? (
                  data.map((item, idx) => (
                    <tr key={idx}>
                      <td>{idx + 1}</td>
                      <td className="fw-semibold">{item?.player?.name || item?.name || "-"}</td>
                      <td>{item?.ageCategory?.name || item?.age || item?.player?.age || "-"}</td>
                      <td>{item?.gender || item?.sex || item?.player?.sex || "-"}</td>
                      <td>{item?.phone || item?.mobile || item?.player?.phone || "-"}</td>
                      <td>
                        <span
                          className={`badge badge-sm ${item?.status === "Active" || item?.status === "Enabled"
                              ? "badge-success"
                              : "badge-secondary"
                            }`}
                        >
                          {item?.status || "Registered"}
                        </span>
                      </td>
                    </tr>
                  ))
                ) : (
                  <tr>
                    <td colSpan={6} className="text-center py-4 text-muted">
                      No recent registrations found
                    </td>
                  </tr>
                )}
              </tbody>
            </Table>
          </div>
        )}
      </Modal.Body>
      <Modal.Footer className="d-flex justify-content-between">
        <Button variant="outline-secondary" onClick={onHide}>
          Close
        </Button>
        <Button variant="primary" onClick={handleShowMore}>
          <i className="fas fa-external-link-alt me-2"></i> Show More (View Full Report)
        </Button>
      </Modal.Footer>
    </Modal>
  );
};

export default RegistrationSummaryModal;
